import { render, staticRenderFns } from "./profitCancel.vue?vue&type=template&id=20d1079e&scoped=true"
import script from "./profitCancel.vue?vue&type=script&lang=js"
export * from "./profitCancel.vue?vue&type=script&lang=js"
import style0 from "./profitCancel.vue?vue&type=style&index=0&id=20d1079e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_3rwm2qttujvjuolkwtduiruple/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d1079e",
  null
  
)

export default component.exports